import { RequiredVariantProps } from '@src/typings';
import { CalendarPickerProps, InputProps } from 'antd-mobile';
import type { RangePickerProps as AntdRangePickerProps } from 'antd/es/date-picker';
import { FormItemLayout } from 'antd/es/form/Form';
import { FormItemInputProps } from 'antd/es/form/FormItemInput';
import dayjs, { Dayjs } from 'dayjs';
import { ReactNode } from 'react';
import { DefaultTheme } from 'styled-components';
import type { Simplify } from 'type-fest';

export type PresetItem = {
    label: string;
    value: [Dayjs, Dayjs];
};
export type Presets = PresetItem[];

export const PresetsDatePicker: Presets = [
    { label: 'Today', value: [dayjs(), dayjs()] },
    {
        label: 'Yesterday',
        value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')],
    },
    { label: 'Last 7 Days', value: [dayjs().subtract(6, 'day'), dayjs()] },
    { label: 'Last 30 Days', value: [dayjs().subtract(29, 'day'), dayjs()] },
    {
        label: 'This Month',
        value: [dayjs().startOf('month'), dayjs().endOf('month')],
    },
    {
        label: 'Last Month',
        value: [
            dayjs().subtract(1, 'month').startOf('month'),
            dayjs().subtract(1, 'month').endOf('month'),
        ],
    },
];

export type RangeCalendarVariant = 'desktop' | 'mobile';

export type RangeCalenderProps = Simplify<
    Omit<
        CalendarPickerProps,
        'value' | 'defaultValue' | 'onChange' | 'selectionMode'
    > &
        Omit<
            AntdRangePickerProps,
            'value' | 'defaultValue' | 'onChange' | 'picker'
        > & {
            variant?: RangeCalendarVariant;
            value?: [Dayjs, Dayjs] | [Date, Date];
            defaultValue?: [Dayjs, Dayjs] | [Date, Date] | null;
            onChange?: (range: [Dayjs, Dayjs] | [Date, Date] | null) => void;

            mobileValue?: [Date, Date] | null;
            defaultMobileValue?: [Date, Date] | null;
            onMobileChange?: (range: [Date, Date] | null) => void;

            desktopValue?: [Dayjs, Dayjs] | null;
            defaultDesktopValue?: [Dayjs, Dayjs] | null;
            onDesktopChange?: (range: [Dayjs, Dayjs] | null) => void;

            presets?: Presets;
            placement?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
            allowClear?: boolean;
            disabled?: boolean;
            format?: string;
            disabledDate?: (date: [Dayjs, Dayjs] | [Date, Date]) => boolean;
            placeholder?: string;
            name?: string;
            layoutLabel?: FormItemLayout | undefined;
            status?: 'error' | 'warning' | 'success';
            size?: 'small' | 'middle' | 'large';
            renderFooter?: () => ReactNode;
            className?: string;
            inputMobileProps?: InputProps;
            formItemProps?: FormItemInputProps;
            theme?: DefaultTheme;
            required?: boolean;
            singleMonthView?: boolean;
            isWithoutFooter?: boolean;
            open?: boolean;
            onOpenChange?: (e: boolean, isCancel?: boolean) => void;
        } & RequiredVariantProps<() => void>
>;
